import * as requestTypes from '../store/requestTypes';

const getCookie = function (name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
};

const getQueryString = function (field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
};

const getAuthorization = function () {
    let auth = 'Basic ';
    const IS_LOCAL = process.env.REACT_APP_IS_LOCAL_AUTH;
    if(IS_LOCAL) {
        return IS_LOCAL;
    }
    const querystring = window.location.href.split('?');
    if (querystring && querystring[1]) {
        const q = [getQueryString('token'), getQueryString('id')].join('+');
        auth += q;
        document.cookie = 'authentication=' + q + '; expires=Fri, 31 Dec 9999 23:59:59 GMT';
    } else {
        const q = getCookie('authentication');
        auth += q;
    }
    return auth;
};

export const isAuthorized = function () {
    if (getAuthorization().length > 20) return true;
    return false;
};

export const reqHeader = {
    method: 'GET',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': getAuthorization()
    }
};
export const initialState = {
    isLoaded: false,
    show_Loader: false
};

export function switchCaseForDefaultActionTypesForReducers(action, state) {
    switch (action.type) {
        case requestTypes.requestType.type:
            return { ...state };
        case requestTypes.requestStartType.type:
            return { ...state, isLoaded: false };
        case requestTypes.showLoader.type:
            return { ...state, show_Loader: action.value };
        case requestTypes.isLoaded.type:
            return { ...state, isLoaded: action.value };
        case requestTypes.requesterrorType.type:
            return { ...state, isLoaded: true };
        default:
            return state;
    }
}